/* Corals Anonymous: prevent duplicate Shipping Box Charge cart lines. */
(() => {
  if (window.__caBoxGuardInstalled) return;
  window.__caBoxGuardInstalled = true;
  document.documentElement.dataset.caBoxGuard = "installed";

  const BOX_PRODUCT_ID = 8216362287330;
  const ROOT = window.Shopify?.routes?.root || "/";
  const RELOAD_KEY = "ca-box-guard-last-reload";
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  let queue = Promise.resolve();
  let reloadScheduled = false;

  async function getCart() {
    const response = await fetch(`${ROOT}cart.js`, {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) throw new Error(`Unable to read cart (${response.status})`);
    return response.json();
  }

  async function updateLines(updates) {
    const response = await fetch(`${ROOT}cart/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) throw new Error(`Unable to update cart (${response.status})`);
    return response.json();
  }

  async function normalizeBoxCharge() {
    let changed = false;

    // Repeat because Cart Bot and Bird can finish in either order.
    for (let pass = 0; pass < 3; pass += 1) {
      const cart = await getCart();
      const boxes = cart.items.filter(
        (item) => Number(item.product_id) === BOX_PRODUCT_ID,
      );
      const boxQuantity = boxes.reduce((sum, item) => sum + item.quantity, 0);

      if (boxQuantity <= 1) return changed;

      // Preserve the line carrying Bird's delivery information when possible.
      const keeper =
        boxes.find((item) => item.properties?._BirdChimeSlotId) || boxes[0];
      const updates = {};

      for (const item of boxes) {
        updates[item.key] = item.key === keeper.key ? 1 : 0;
      }

      await updateLines(updates);
      changed = true;
      await sleep(350);
    }

    return changed;
  }

  function refreshCartPageOnce() {
    if (reloadScheduled || !/^\/cart\/?$/.test(window.location.pathname)) return;

    const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - lastReload < 5000) return;

    reloadScheduled = true;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
  }

  function runGuard() {
    queue = queue
      .catch(() => undefined)
      .then(async () => {
        const changed = await normalizeBoxCharge();
        if (changed) refreshCartPageOnce();
        else sessionStorage.removeItem(RELOAD_KEY);
      })
      .catch((error) => console.error("Box charge guard:", error));
  }

  // Catch initial app loading, slower connections, and a selected Bird slot.
  window.addEventListener("pageshow", () => {
    setTimeout(runGuard, 1000);
    setTimeout(runGuard, 3000);
    setTimeout(runGuard, 6000);
  });
  document.addEventListener("birdchime:schedule", () => setTimeout(runGuard, 300));

  // These events cover common AJAX-cart implementations when present.
  document.addEventListener("cart:updated", runGuard);
  document.addEventListener("cart:refresh", runGuard);
})();